(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1047px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // PC 端首页导航悬浮时，保留公告栏占位空间并处理滚动切换
  (function () {
    const homepageHeader = document.querySelector('.header-wrapper--homepage-hero');
    if (!homepageHeader) return;

    const announcementBar = document.querySelector('.announcement-bar-section');
    let barHeight = 0;
    let scrollThreshold = 0;
    let ticking = false;
    let isScrolled = false; // PC 端背景是否已切换为实底

    function updateSizes() {
      if (window.innerWidth < 1048) {
        homepageHeader.style.removeProperty('--announcement-bar-height');
        homepageHeader.style.removeProperty('--announcement-bar-visible-height');
        homepageHeader.classList.remove('header-wrapper--scrolled');
        isScrolled = false;
        return;
      }

      barHeight = announcementBar ? announcementBar.offsetHeight : 0;
      scrollThreshold = barHeight + homepageHeader.offsetHeight;
      homepageHeader.style.setProperty('--announcement-bar-height', `${barHeight}px`);
      updatePosition();
    }

    function updatePosition() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const visibleHeight = Math.max(0, barHeight - scrollTop);
      homepageHeader.style.setProperty('--announcement-bar-visible-height', `${visibleHeight}px`);

      if (!isScrolled) {
        if (scrollTop >= scrollThreshold) {
          isScrolled = true;
          homepageHeader.classList.add('header-wrapper--scrolled');
        }
      } else if (scrollTop <= scrollThreshold - barHeight) {
        // 上滑时不立即切换背景，需向上滑动超过公告栏高度后才切回透明
        isScrolled = false;
        homepageHeader.classList.remove('header-wrapper--scrolled');
      }
    }

    function onScroll() {
      if (window.innerWidth < 1048) return;
      if (!ticking) {
        requestAnimationFrame(() => {
          updatePosition();
          ticking = false;
        });
        ticking = true;
      }
    }

    updateSizes();
    window.addEventListener('resize', updateSizes);
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
